<figure class="resume-hero-photo">
  <img
    ngSrc="/images/r67.webp"
    width="742"
    height="960"
    alt="Russ on bass at a venue performance"
    sizes="(max-width: 48rem) 100vw, 19rem"
    priority
  />
  <figcaption>Russ on bass — live performance.</figcaption>
</figure>

<h2>Currently Teaching</h2>
<ul>
  <li>
    <a [routerLink]="'/'"> Live Online Lessons </a>
    - World Wide Using Zoom
  </li>
  <li>Watch &amp; Learn - Downloadable Instructional Bass Videos</li>
</ul>

<h2>Teaching Experience</h2>
<ul>
  <li>
    Bass Guitar Private Instruction - (1982 to Present) - Specializing in the
    instruction of all aspects of bass guitar performance.
  </li>
  <li>
    Atlanta Bass Gallery - Atlanta, GA - (2009 to 2014) - Director of Bass
    Guitar Instruction.
  </li>
  <li>
    Ken Stanton Music - Alpharetta, GA - (1999 to 2014) - Bass Guitar
    Instructor.
  </li>
  <li>
    East Cobb Music Academy Marietta, GA - (1998 to 2005) - Director of Bass
    Guitar Instruction.
  </li>
  <li>
    Atlanta Institute of Music - (1985 to 1991) and (1999 to 2013) - Founder and
    Director of the bass program, responsible for all aspects of bass guitar
    instruction, including the production and the use of specialized training
    aids using the latest technology.
  </li>
</ul>

<h2>Performance Experience</h2>
<ul>
  <li>
    Currently - Actively freelancing across South Florida (Boynton Beach, FL).
  </li>
  <li>
    12 years (2014 to 2026) - Active freelance bass player throughout the
    Washington DC, Maryland, and Northern Virginia area.
  </li>
  <li>
    8 years as the House Bass Player for the Ritz Carlton Jazz Trio, Featuring
    Theresa Hightower - Atlanta, GA.
  </li>
  <li>Local performances with the Electromatics - Atlanta, GA.</li>
  <li>Local and national performances and recordings with Francine Reed.</li>
  <li>
    Local performances and recordings with Henry Parrilla's Widespread Hispanic
    - Atlanta, GA.
  </li>
  <li>The League of Decency, Atlanta's favorite swing band - Atlanta, GA.</li>
  <li>
    Nationwide tour of Japan and Malaysia with Ichiban recording artist The 3
    Degrees, including performances at Blue Note Jazz Clubs in Japan.
  </li>
  <li>
    Ruperts Orchestra, Atlanta convention and private party band - Atlanta, GA.
  </li>
  <li>
    The Ritz Carlton Orchestra for The Mayfair Artists Agency - Atlanta, GA.
  </li>
  <li>
    Eric Quincy Tate, former Capricorn Records Southern Rock recording artist -
    Atlanta, GA.
  </li>
  <li>
    The Paul Mitchell Trio at Dante's Down the Hatch, one of Atlanta's premier
    restaurants and Jazz Clubs over 25 years - Atlanta, GA.
  </li>
  <li>Tom Grose and the Varsity - Atlanta, GA.</li>
  <li>Mocha, National touring Motown Trio.</li>
  <li>Jerry Farber's Comedy Club, unique Jazz pianist and comedy act.</li>
  <li>Royal Caribbean Cruise Line, Ship's Premier Show Orchestra.</li>
</ul>

<h2>Recording Experience</h2>
<ul>
  <li>
    National radio ad for Holiday Inn Express - Crawford Studio, Atlanta, GA.
  </li>
  <li>
    National radio and TV ad for Papa John's Pizza - Doppler Studio - Atlanta,
    GA.
  </li>
  <li>Turner Classic Movies TV ads - Doppler Studio, Atlanta, GA.</li>
  <li>Miami Cuban Television ad - Crawford Studio, Atlanta, GA.</li>
  <li>
    Various soundtracks for Georgia Public Television documentaries - recorded
    at Kala Studio, Atlanta, GA.
  </li>
  <li>
    Swing compilation CDs for Platinum Records - Doppler Studio, Atlanta, GA.
  </li>
  <li>Many CDs for local and regional artists, including Francine Reed.</li>
</ul>

<h2>Bass Skills Include</h2>
<ul>
  <li>
    All aspects and styles of bass guitar performance and instruction, with
    professional experience on 4, 5, and 6 string fretted and fretless basses.
  </li>
</ul>
